<template>
	<div>
	    <div v-if="buildingFields.length" class="flex justify-between">
			<div>
				<div class="grid grid-cols-5 gap-x-4 gap-y-6">
					<div v-for="(row, rowIndex) in buildingFields" :key="rowIndex" class="flex flex-col">
						<label :for="row.field">{{ row.label }}</label>
						<div>
							<div v-if="row.type == 'text'">
								<input :name="row.field" v-model="building[row.field]" class="form-input text-xl" :size="row.size">
							</div>
							<div v-else-if="row.type == 'integer' || row.type == 'double'">
								<number-input :name="row.field" :size="row.size" v-model="building[row.field]" :is-decimal="row.type == 'double'"></number-input>
							</div>
							<div v-else-if="row.type == 'percentage'">
								<percent-input :name="row.field" :size="row.size" add-classes="text-xl" v-model="building[row.field]"></percent-input>
							</div>
							<div v-else-if="row.type == 'currency'">
								<currency-input v-model="building[row.field]" :size="row.size" name='row.field' add-classes="text-xl" is-decimal></currency-input>
							</div>
							<div v-else-if="row.type == 'value-list'">
								<select v-model="building[row.field]" :name="row.field" class="mt-0 form-select text-xl max-w-fit">
									<option value=""></option>
									<option v-for="(option, optionIndex) in row.options" :key="optionIndex" :value="option.option">{{ option.option }}</option>
								</select>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="ml-10 mt-4 w-1/5">
				<div v-for="(row, rowIndex) in buildingToggleFields" :key="rowIndex" class="mb-6 flex items-center justify-between">
					<label :for="row.field">{{ row.label }}</label>
					<div>
						<toggle-switch v-model="building[row.field]" :name="row.field"></toggle-switch>
					</div>
				</div>
			</div>
	    </div>
	</div>
</template>

<script>
    export default {
    	props: {
    		buildingData: {
    			type: Object,
    			required: true
    		}
    	},

    	data() {
    		return {
    			building: this.buildingData,

    			buildingTypes: {}
    		}
    	},

        created() {
        	console.log(this.building);
            this.initBuildingTypes();
        },

		computed: {
			buildingFields() {
				if (this.buildingTypes.length && this.building.type_id != null) {
					let fields = _.find(this.buildingTypes, ['id', this.building.type_id]).fields;

					return _.remove(fields, (field) => {
						return field.type != 'boolean'
					});
				}

				return [];
			},

			buildingToggleFields() {
				if (this.buildingTypes.length && this.building.type_id != null) {
					let fields = _.find(this.buildingTypes, ['id', this.building.type_id]).fields;
					
					return _.remove(fields, (field) => {
						return field.type == 'boolean'
					});
				}

				return [];
			}
		},

        methods: {
            initBuildingTypes() {
                axios.get('/api/building-types').then((response) => {
                    this.buildingTypes = response.data.types;
                }).catch((error) => {
                    console.log(error);
                });
            },
        }
    }
</script>